// import React, { useState, useEffect } from 'react';
// import { useFormik } from 'formik';
// import * as Yup from 'yup';
// import { User } from '../../app/modules/apps/data-administration/data-admininstration-list/core/_models';
// import { errorToast, successToast } from './components/Toaster';

// interface CommitmentFormProps {
//     user?: User | any
//     isCommitmentLoading?: boolean;
//     commitment?: CommitmentData;
//     onClose?: () => void;
// }

// interface CommitmentData {
//     id?: string;
//     quantity: number;
//     categoryId: string;
//     sponsorId: string;
//     sponsorName: string;
//     itemId: string;
//     completionDate: number;
//     commitmentType: string;
//     remarks?: string;
//     environment: string;
//     orderId?: string;
// }

// interface EligibleOrder {
//     id: string;
//     orderId: string;
//     customerName?: string;
//     createdByName?: string;
//     latitude?: string;
//     longitude?: string;
//     orderDetail?: Array<{
//         items: Array<{
//             itemName: string;
//             quantity: number;
//             unit: string;
//         }>;
//     }>;
//     [key: string]: any;
// }

// const CommitmentFormEdit: React.FC<CommitmentFormProps> = ({ user = {}, commitment = {}, isCommitmentLoading = false }) => {
//     console.log("user is this .......,", user)

//     const [loading, setLoading] = useState(false);
//     const [showToast, setShowToast] = useState(false);
//     const [toastMessage, setToastMessage] = useState('');
//     const [toastType, setToastType] = useState('success');

//     const [eligibleOrders, setEligibleOrders] = useState<EligibleOrder[]>([]);
//     const [loadingEligibleOrders, setLoadingEligibleOrders] = useState(false);
//     const [selectedOrderDetails, setSelectedOrderDetails] = useState<EligibleOrder | null>(null);
//     const [quantity, setQuantity] = useState<string>('');

//     const [commitmentForEdit] = useState<any>({
//         ...user,
//         listingId: user?.listingId || ''
//     });

//     const getTokenFromStorage = () => {
//         const authData = localStorage.getItem('kt-auth-react-v');
//         if (authData) {
//             try {
//                 const parsedData = JSON.parse(authData);
//                 return parsedData.data?.token;
//             } catch (e) {
//                 console.error('Error parsing auth data:', e);
//             }
//         }
//         return null;
//     };

//     const validationSchema = Yup.object({
//         listingId: Yup.string().required('Listing ID is required')
//     });

//     const formik = useFormik({
//         initialValues: commitmentForEdit,
//         validationSchema,
//         onSubmit: async (values, { setSubmitting }) => {
//             const token = getTokenFromStorage();
//             if (!token) {
//                 setToastType('error');
//                 setToastMessage('Authentication token not found. Please login again.');
//                 setShowToast(true);
//                 setTimeout(() => setShowToast(false), 3000);
//                 return;
//             }

//             setLoading(true);
//             setSubmitting(true);

//             try {
//                 const payload = {
//                     listingId: values.listingId,
//                     quantity: quantity,
//                     orderId: user?.orderId || `${Date.now()}_${Math.floor(Math.random() * 1000)}`,
//                 };

//                 const isEdit = user?.id;
//                 const url = isEdit
//                     ? `${process.env.REACT_APP_BASE_API_URL}commitments/${user.id}/update`
//                     : `${process.env.REACT_APP_BASE_API_URL}commitment`;

//                 const method = isEdit ? 'PUT' : 'POST';

//                 const response = await fetch(url, {
//                     method: method,
//                     headers: {
//                         'Authorization': `Bearer ${token}`,
//                         'Content-Type': 'application/json',
//                     },
//                     body: JSON.stringify(payload)
//                 });

//                 if (response.ok) {
//                     // successToast(isEdit ? 'Commitment updated successfully!' : 'Commitment submitted successfully!')
//                     setTimeout(() => setShowToast(false), 3000);
//                     setTimeout(() => {
//                         window.location.reload();
//                     }, 1000);
//                     if (!isEdit) {
//                         formik.resetForm();
//                         setQuantity('');
//                     }
//                 } else {
//                     const errorData = await response.json().catch(() => ({}));
//                     throw new Error(errorData.message || `Failed to ${isEdit ? 'update' : 'submit'} commitment`);
//                 }
//             } catch (error) {
//                 // setToastType('error');
//                 // setToastMessage((error as Error)?.message || `Failed to ${user?.id ? 'update' : 'submit'} commitment. Please try again.`);
//                 console.error('Submission error:', error);
//             } finally {
//                 setLoading(false);
//                 setSubmitting(false);
//                 // setShowToast(true);
//                 setTimeout(() => setShowToast(false), 3000);
//             }
//         }
//     });

//     const handleListingIdChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//         const selectedId = e.target.value;
//         formik.setFieldValue('listingId', selectedId);

//         if (selectedId) {
//             const selectedOrder = eligibleOrders.find(order => order.id === selectedId);
//             setSelectedOrderDetails(selectedOrder || null);
//         } else {
//             setSelectedOrderDetails(null);
//         }
//     };

//     const fetchEligibleOrders = async () => {
//         const token = getTokenFromStorage();
//         if (!token) return;

//         setLoadingEligibleOrders(true);
//         try {
//             const response = await fetch(`${process.env.REACT_APP_BASE_API_URL}eligibleOrders/${user.id}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Content-Type': 'application/json'
//                 }
//             });
//             const data: any = await response.json();
//             console.log('API Response:', data);

//             if (Array.isArray(data)) {
//                 setEligibleOrders(data);
//             } else if (data && Array.isArray(data.data)) {
//                 setEligibleOrders(data.data);
//             } else if (data && Array.isArray(data.content)) {
//                 setEligibleOrders(data.content);
//             } else if (data && typeof data === 'object') {
//                 setEligibleOrders([data]);
//             } else {
//                 setEligibleOrders([]);
//             }
//         } catch (error) {
//             console.error('Failed to fetch eligible orders:', error);
//             errorToast('Failed to fetch eligible orders');
//             setEligibleOrders([]);
//         } finally {
//             setLoadingEligibleOrders(false);
//         }
//     };

//     useEffect(() => {
//         fetchEligibleOrders();
//     }, []);

//     const isEdit = !!user?.id;

//     return (
//         <div style={{ padding: '30px', fontFamily: 'Arial, sans-serif' }}>
//             <style>
//                 {`
//                     .custom-form * {
//                         color: #000000 !important;
//                     }
//                     .custom-form label {
//                         color: #000000 !important;
//                         font-weight: bold !important;
//                     }
//                     .custom-form label:hover {
//                         color: #000000 !important;
//                     }
//                     .custom-form input, .custom-form select, .custom-form textarea {
//                         background-color: #ffffff !important;
//                         border: 1px solid #808080 !important;
//                     }
//                     .custom-form input:disabled, .custom-form select:disabled {
//                         background-color: #ffffff !important;
//                         opacity: 0.7;
//                     }
//                 `}
//             </style>

//             {showToast && (
//                 <div style={{
//                     position: 'fixed',
//                     top: '20px',
//                     right: '20px',
//                     padding: '15px',
//                     borderRadius: '5px',
//                     backgroundColor: toastType === 'success' ? '#28a745' : '#dc3545',
//                     color: 'white',
//                     zIndex: 10000
//                 }}>
//                     {toastMessage}
//                 </div>
//             )}

//             <form id="commitment-form" onSubmit={formik.handleSubmit} noValidate className="custom-form">
//                 <div>
//                     {/* Select Listing ID */}
//                     <div style={{ marginBottom: '25px' }}>
//                         <label style={{
//                             display: 'block',
//                             marginBottom: '10px',
//                             fontWeight: 'bold',
//                             color: '#000000',
//                             fontSize: '14px'
//                         }}>
//                             Select Listing ID *
//                         </label>
//                         <select
//                             value={formik.values.listingId}
//                             onChange={handleListingIdChange}
//                             disabled={loadingEligibleOrders || formik.isSubmitting || isCommitmentLoading}
//                             style={{
//                                 width: '100%',
//                                 padding: '12px',
//                                 backgroundColor: '#ffffff',
//                                 border: '1px solid #808080',
//                                 borderRadius: '5px',
//                                 color: '#000000',
//                                 fontSize: '14px',
//                                 outline: 'none'
//                             }}
//                         >
//                             <option value="">{loadingEligibleOrders ? 'Loading...' : 'Select Listing ID'}</option>
//                             {eligibleOrders.map((order) => {
//                                 const totalQuantity = order.orderDetail?.reduce((sum, detail) => {
//                                     return sum + detail.items.reduce((itemSum, item) => itemSum + item.quantity, 0);
//                                 }, 0) || 0;

//                                 return (
//                                     <option key={order.id} value={order.id}>
//                                         {[
//                                             order.hubName,
//                                             order.actualProcessDate?.split('T')[0],
//                                             order.orderId,
//                                             `${totalQuantity} ${order.orderDetail?.[0]?.items?.[0]?.unit || 'KG'}`
//                                         ].filter(Boolean).join(' - ')}
//                                     </option>
//                                 );
//                             })}
//                         </select>
//                         {formik.touched.listingId && formik.errors.listingId && (
//                             <div style={{ color: '#dc3545', fontSize: '13px', marginTop: '5px' }}>
//                                 {String(formik.errors.listingId)}
//                             </div>
//                         )}
//                     </div>

//                     {selectedOrderDetails && (
//                         <div>
//                             {/* Supply Partner */}
//                             <div style={{ marginBottom: '25px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '10px',
//                                     fontWeight: 'bold',
//                                     color: '#000000',
//                                     fontSize: '14px'
//                                 }}>
//                                     Supply Partner
//                                 </label>
//                                 <input
//                                     type="text"
//                                     value={selectedOrderDetails.customerName || selectedOrderDetails.createdByName || 'N/A'}
//                                     disabled
//                                     style={{
//                                         width: '100%',
//                                         padding: '12px',
//                                         backgroundColor: '#ffffff',
//                                         border: '1px solid #808080',
//                                         borderRadius: '5px',
//                                         color: '#000000',
//                                         fontSize: '14px',
//                                         outline: 'none'
//                                     }}
//                                 />
//                             </div>

//                             {/* Address */}
//                             <div style={{ marginBottom: '25px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '10px',
//                                     fontWeight: 'bold',
//                                     color: '#000000',
//                                     fontSize: '14px'
//                                 }}>
//                                     Address
//                                 </label>
//                                 <input
//                                     type="text"
//                                     value={selectedOrderDetails.latitude && selectedOrderDetails.longitude
//                                         ? `Lat: ${selectedOrderDetails.latitude}, Long: ${selectedOrderDetails.longitude}`
//                                         : 'Address not available'}
//                                     disabled
//                                     style={{
//                                         width: '100%',
//                                         padding: '12px',
//                                         backgroundColor: '#ffffff',
//                                         border: '1px solid #808080',
//                                         borderRadius: '5px',
//                                         color: '#000000',
//                                         fontSize: '14px',
//                                         outline: 'none'
//                                     }}
//                                 />
//                             </div>

//                             {/* Item Details Table */}
//                             <div style={{ marginBottom: '25px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '10px',
//                                     fontWeight: 'bold',
//                                     color: '#000000',
//                                     fontSize: '14px'
//                                 }}>
//                                     Item Details
//                                 </label>
//                                 <table style={{
//                                     width: '100%',
//                                     borderCollapse: 'collapse',
//                                     border: '1px solid #808080',
//                                     backgroundColor: '#ffffff'
//                                 }}>
//                                     <thead>
//                                         <tr style={{ backgroundColor: '#f5f5f5' }}>
//                                             <th style={{
//                                                 padding: '15px',
//                                                 border: '1px solid #808080',
//                                                 fontWeight: 'bold',
//                                                 color: '#000000',
//                                                 textAlign: 'left'
//                                             }}>
//                                                 Item name
//                                             </th>
//                                             <th style={{
//                                                 padding: '15px',
//                                                 border: '1px solid #808080',
//                                                 fontWeight: 'bold',
//                                                 color: '#000000',
//                                                 textAlign: 'left'
//                                             }}>
//                                                 Quantity
//                                             </th>
//                                             <th style={{
//                                                 padding: '15px',
//                                                 border: '1px solid #808080',
//                                                 fontWeight: 'bold',
//                                                 color: '#000000',
//                                                 textAlign: 'left'
//                                             }}>
//                                                 Unit
//                                             </th>
//                                         </tr>
//                                     </thead>
//                                     <tbody>
//                                         {selectedOrderDetails.orderDetail?.map((detail: any, detailIndex: number) =>
//                                             detail.items?.map((item: any, itemIndex: number) => (
//                                                 <tr key={`${detailIndex}-${itemIndex}`}>
//                                                     <td style={{
//                                                         padding: '12px',
//                                                         border: '1px solid #808080',
//                                                         color: '#000000',
//                                                         backgroundColor: '#ffffff'
//                                                     }}>
//                                                         {item.itemName}
//                                                     </td>
//                                                     <td style={{
//                                                         padding: '12px',
//                                                         border: '1px solid #808080',
//                                                         color: '#000000',
//                                                         backgroundColor: '#ffffff'
//                                                     }}>
//                                                         {item.quantity}
//                                                     </td>
//                                                     <td style={{
//                                                         padding: '12px',
//                                                         border: '1px solid #808080',
//                                                         color: '#000000',
//                                                         backgroundColor: '#ffffff'
//                                                     }}>
//                                                         {item.unit}
//                                                     </td>
//                                                 </tr>
//                                             ))
//                                         )}
//                                     </tbody>
//                                 </table>
//                             </div>

//                             {/* Quantity Input */}
//                             <div style={{ marginBottom: '25px' }}>
//                                 <label style={{
//                                     display: 'block',
//                                     marginBottom: '10px',
//                                     fontWeight: 'bold',
//                                     color: '#000000',
//                                     fontSize: '14px'
//                                 }}>
//                                     Quantity
//                                 </label>
//                                 <input
//                                     type="number"
//                                     value={quantity}
//                                     onChange={(e) => setQuantity(e.target.value)}
//                                     placeholder="Enter quantity"
//                                     style={{
//                                         width: '100%',
//                                         padding: '12px',
//                                         backgroundColor: '#ffffff',
//                                         border: '1px solid #808080',
//                                         borderRadius: '5px',
//                                         color: '#000000',
//                                         fontSize: '14px',
//                                         outline: 'none'
//                                     }}
//                                 />
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             </form>
//         </div>
//     );
// };

// export default CommitmentFormEdit;






import React, { useState, useEffect } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import Select from 'react-select';
import { errorToast, successToast } from './components/Toaster';

interface CommitmentFormProps {
    user?: any
    isCommitmentLoading?: boolean;
    onClose?: () => void;
}

const CommitmentFormEdit: React.FC<CommitmentFormProps> = ({ user = {}, isCommitmentLoading = false }) => {
    const [franchises, setFranchises] = useState<any[]>([]);
    const [pickupPoints, setPickupPoints] = useState<any[]>([]);
    const [selectedFranchiseId, setSelectedFranchiseId] = useState('');
    const [selectedPickupPoints, setSelectedPickupPoints] = useState<any[]>([]);
    const [loadingFranchises, setLoadingFranchises] = useState(false);
    const [loadingPickupPoints, setLoadingPickupPoints] = useState(false);
    const [loading, setLoading] = useState(false);

    const getTokenFromStorage = () => {
        const authData = localStorage.getItem('kt-auth-react-v');
        if (authData) {
            try {
                const parsedData = JSON.parse(authData);
                return parsedData.data?.token;
            } catch (e) {
                console.error('Error parsing auth data:', e);
            }
        }
        return null;
    };

    const validationSchema = Yup.object({
        pickupPoint: Yup.array().min(1, 'Select at least one pickup point')
    });

    const formik = useFormik({
        initialValues: {
            pickupPoint: user?.pickupPoint || []
        },
        validationSchema,
        onSubmit: async (values) => {
            const token = getTokenFromStorage();
            if (!token) return;

            setLoading(true);
            try {
                const payload = {
                    sponsorId: user?.sponsorId,
                    sponsorName: user?.sponsorName,
                    startDate: user?.startDate,
                    endDate: user?.endDate,
                    packageId: user?.packageId,
                    pickupPoint: selectedPickupPoints.map(p => p.value)
                };

                const response = await fetch(
                    `${process.env.REACT_APP_BASE_API_URL}sponsorCommitments/${user.id}`,
                    {
                        method: 'PUT',
                        headers: {
                            'Authorization': `Bearer ${token}`,
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify(payload)
                    }
                );

                if (response.ok) {
                    successToast('Updated successfully!');
                } else {
                    errorToast('Failed to update');
                }
            } catch (error) {
                console.error('Error:', error);
            } finally {
                setLoading(false);
            }
        }
    });

    const fetchFranchises = async () => {
        const token = getTokenFromStorage();
        if (!token) return;

        setLoadingFranchises(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=FRANCHISE`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            const data = await response.json();
            setFranchises(data.content || data || []);
        } catch (error) {
            console.error('Failed to fetch franchises:', error);
        } finally {
            setLoadingFranchises(false);
        }
    };

    const fetchPickupPoints = async (franchiseId: string) => {
        const token = getTokenFromStorage();
        if (!token || !franchiseId) return;

        setLoadingPickupPoints(true);
        try {
            const response = await fetch(
                `${process.env.REACT_APP_BASE_API_URL}users?page=0&size=10&type=PICKUP_POINT&facilityType=COLLECTION_TYPE%2CMRF%2CAGGREGATOR%2CDIVERSION_FACILITY%2CFLEET&franchiseId=${franchiseId}`,
                {
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            const data = await response.json();
            setPickupPoints(data.content || data || []);
        } catch (error) {
            console.error('Failed to fetch pickup points:', error);
        } finally {
            setLoadingPickupPoints(false);
        }
    };

    const handleFranchiseChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        const franchiseId = e.target.value;
        setSelectedFranchiseId(franchiseId);
        setPickupPoints([]);
        setSelectedPickupPoints([]);

        if (franchiseId) {
            fetchPickupPoints(franchiseId);
        }
    };

    const pickupPointOptions = pickupPoints.map((point) => ({
        value: point.id,
        label: point.personalDetails?.name || 'Unknown'
    }));

    useEffect(() => {
        fetchFranchises();
    }, []);

    const customStyles = {
        control: (base: any) => ({
            ...base,
            backgroundColor: '#ffffff',
            borderColor: '#808080',
            border: '1px solid #808080',
            borderRadius: '5px',
            padding: '8px',
            color: '#000000',
            fontSize: '14px',
            cursor: 'pointer',
            '&:hover': {
                borderColor: '#808080',
                backgroundColor: '#ffffff'
            },
            boxShadow: 'none'
        }),
        option: (base: any, state: any) => ({
            ...base,
            backgroundColor: state.isSelected ? '#000000' : '#ffffff',
            color: state.isSelected ? '#ffffff' : '#000000',
            cursor: 'pointer',
            '&:hover': {
                backgroundColor: '#f0f0f0',
                color: '#000000'
            }
        }),
        menu: (base: any) => ({
            ...base,
            backgroundColor: '#ffffff',
            borderColor: '#808080',
            zIndex: 9999

        }),
        menuList: (base: any) => ({
            ...base,
            backgroundColor: '#ffffff',
            zIndex: 9999
        }),
        multiValue: (base: any) => ({
            ...base,
            backgroundColor: 'gray',
            color: '#ffffff'
        }),
        multiValueLabel: (base: any) => ({
            ...base,
            color: '#ffffff'
        }),
        multiValueRemove: (base: any) => ({
            ...base,
            color: '#ffffff',
            '&:hover': {
                backgroundColor: '#dc3545',
                color: '#ffffff'
            }
        })
    };

    return (
        // <form onSubmit={formik.handleSubmit} style={{ padding: '30px', fontFamily: 'Arial, sans-serif' }}>
        <form onSubmit={formik.handleSubmit} id="commitment-form" style={{ padding: '30px', fontFamily: 'Arial, sans-serif' }}>
            {/* Select Country/Franchise */}
            <div style={{ marginBottom: '25px' }}>
                <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold', color: '#000000' }}>
                    Select Country *
                </label>
                <select
                    value={selectedFranchiseId}
                    onChange={handleFranchiseChange}
                    disabled={loadingFranchises || isCommitmentLoading}
                    style={{
                        width: '100%',
                        padding: '12px',
                        backgroundColor: '#ffffff',
                        border: '1px solid #808080',
                        borderRadius: '5px',
                        color: '#000000',
                        fontSize: '14px',
                        outline: 'none',
                        cursor: 'pointer'
                    }}
                >
                    <option value="">{loadingFranchises ? 'Loading...' : 'Select Country'}</option>
                    {franchises.map((franchise) => (
                        <option key={franchise.id} value={franchise.id}>
                            {franchise.personalDetails?.name || 'Unknown'}
                        </option>
                    ))}
                </select>
            </div>

            {/* Select Pickup Points - Multi Select */}
            {selectedFranchiseId && (
                <div style={{ marginBottom: '25px' }}>
                    <label style={{ display: 'block', marginBottom: '10px', fontWeight: 'bold', color: '#000000' }}>
                        Select Material Hub *
                    </label>
                    <Select
                        isMulti
                        options={pickupPointOptions}
                        value={selectedPickupPoints}
                        onChange={(selected) => {
                            setSelectedPickupPoints(selected || []);
                            formik.setFieldValue('pickupPoint', selected?.map(s => s.value) || []);
                        }}
                        isDisabled={loadingPickupPoints || isCommitmentLoading}
                        styles={customStyles}
                        isLoading={loadingPickupPoints}
                    />
                    {formik.touched.pickupPoint && formik.errors.pickupPoint && (
                        <div style={{ color: '#dc3545', fontSize: '13px', marginTop: '5px' }}>
                            {typeof formik.errors.pickupPoint === 'string' ? formik.errors.pickupPoint : 'Invalid selection'}
                        </div>
                    )}
                </div>
            )}

            {/* Submit Button */}
            {/* <div style={{ marginTop: '30px' }}>
                <button
                    type="submit"
                    disabled={loading || !selectedFranchiseId}
                    style={{
                        padding: '12px 30px',
                        backgroundColor: '#000000',
                        color: 'white',
                        border: 'none',
                        borderRadius: '5px',
                        fontSize: '14px',
                        fontWeight: 'bold',
                        cursor: loading ? 'not-allowed' : 'pointer',
                        opacity: loading ? 0.7 : 1
                    }}
                >
                    {loading ? 'Submitting...' : 'Submit'}
                </button>
            </div> */}
        </form>
    );
};

export default CommitmentFormEdit;